import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';

import * as NotificationsActions from '@collections/notifications/notifications.actions';
import {
  getNotificationsTotalUnread,
  getNotificationsError,
  getNotificationsLoading,
} from '@collections/notifications/notifications.selectors';
import { take, tap, withLatestFrom } from 'rxjs/operators';

@Component({
  selector: 'mojo-notifications-bell',
  templateUrl: './notifications-bell.container.html',
  styleUrls: ['./notifications-bell.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsBellContainerComponent {
  totalUnread$ = this.store.select(getNotificationsTotalUnread);
  loading$ = this.store.select(getNotificationsLoading);

  constructor(private store: Store) {}

  markNotificationsAsRead() {
    this.loading$
      .pipe(
        take(1),
        withLatestFrom(this.store.select(getNotificationsError)),
        tap(([loading, error]) => {
          if (!loading && !error) {
            this.store.dispatch(NotificationsActions.notificationsMarkAsRead());
          } else if (error) {
            this.store.dispatch(NotificationsActions.notificationsClear());
            this.store.dispatch(NotificationsActions.notificationsLoadPage({}));
          }
        }),
      )
      .subscribe();
  }
}
